import Logo from '@/assets/logo.svg?react'
import { CONTAINER_MAX_WIDTH, NAV_BAR_HEIGHT } from '@/config/constants'
import { Box, Button, Flex, HStack, Spacer } from '@chakra-ui/react'
import { AccountSettingsTab } from '@infraloop/account-settings'
import { useTranslation } from '@infraloop/i18n'
import { Link, useLocation } from 'react-router'

import UserMenu from './UserMenu'

/** Style props for the active nav item. */
const ACTIVE_NAV_PROPS = { fontWeight: 'semibold', color: 'gray.800', bg: 'primary.50', _hover: { bg: 'primary.50' } }

/** Style props for an inactive nav item. */
const INACTIVE_NAV_PROPS = {
  fontWeight: 'medium',
  color: 'gray.500',
  bg: 'transparent',
  _hover: { bg: 'blackAlpha.50' },
}

const AppBar = () => {
  // Hooks
  const { t } = useTranslation()
  const location = useLocation()

  // Derived state — each nav item highlights only on its own destination route
  const isProjectListActive = location.pathname === '/'
  const isProjectSettingsActive = location.pathname === `/user/${AccountSettingsTab.InspectionSheet}`

  return (
    <Box
      as="header"
      position="sticky"
      top={0}
      zIndex={30}
      h={`${NAV_BAR_HEIGHT}px`}
      bg="rgba(255,255,255,.88)"
      backdropFilter="saturate(180%) blur(8px)"
      borderBottom="1px solid"
      borderColor="gray.200"
      flexShrink={0}
    >
      <Flex align="center" gap="36px" h="100%" w="100%" maxW={CONTAINER_MAX_WIDTH} mx="auto" px="28px">
        <Box asChild w="auto" flexShrink={0} cursor="pointer">
          <Link to="/" aria-label="Hatsuly" data-testid="nav-logo">
            <Logo height="25px" width="auto" title="Hatsuly" />
          </Link>
        </Box>

        <HStack as="nav" gap="4px">
          <Button
            variant="plain"
            asChild
            h="auto"
            minW="0"
            px="14px"
            py="7px"
            borderRadius="8px"
            fontSize="14px"
            {...(isProjectListActive ? ACTIVE_NAV_PROPS : INACTIVE_NAV_PROPS)}
            data-testid="nav-project-list"
          >
            <Link to="/">{t('hatsuly.nav.projectList')}</Link>
          </Button>
          {/* Opens the account's Inspection Sheet Settings tab (different label, same destination). */}
          <Button
            variant="plain"
            asChild
            h="auto"
            minW="0"
            px="14px"
            py="7px"
            borderRadius="8px"
            fontSize="14px"
            {...(isProjectSettingsActive ? ACTIVE_NAV_PROPS : INACTIVE_NAV_PROPS)}
            data-testid="nav-project-settings"
          >
            <Link to={`/user/${AccountSettingsTab.InspectionSheet}`}>{t('hatsuly.nav.projectSettings')}</Link>
          </Button>
        </HStack>

        <Spacer />

        <UserMenu />
      </Flex>
    </Box>
  )
}

export default AppBar
